/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SegmentResponsePage } from '../../models/segment-response-page';

export interface ListSegments$Params {
  articleId?: string;
  topicId?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'body' | '-body' | 'rewrite' | '-rewrite' | 'isClaim' | '-isClaim' | 'authoritativeEval' | '-authoritativeEval' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'articleId' | '-articleId' | 'articleTitle' | '-articleTitle'>;
}

export function listSegments(http: HttpClient, rootUrl: string, params?: ListSegments$Params, context?: HttpContext): Observable<StrictHttpResponse<SegmentResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listSegments.PATH, 'get');
  if (params) {
    rb.query('articleId', params.articleId, {"style":"form"});
    rb.query('topicId', params.topicId, {"style":"form"});
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SegmentResponsePage>;
    })
  );
}

listSegments.PATH = '/v0/segments';
